/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the AmcApiConfiguration configuration object with a given root URL.
 */
export function provideAmcApiConfiguration(rootUrl: string) {
  var config = new AmcApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: AmcApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class AmcApiConfiguration {
  rootUrl: string = '/';
}

